import {Card, FC, PropsWithChildren} from 'external/react'
import Icon from 'external/fortawesome'

import BasicLayout from './BasicLayout'

const ProfileContainer: FC<PropsWithChildren> = props => {
    const {children} = props

    return (
		<BasicLayout>
			<Card.Header style={{ fontSize: '31px' }} className='card--header'>
			<Icon name="faUser" />Perfil
			</Card.Header>
			{children} 
		</BasicLayout>
	)
}

export {ProfileContainer as default}